import { StockInventoryReportItem } from "@/modules/StockInventory/Types/StockInventory.types";
import { pdf } from "@react-pdf/renderer";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import { InventoryPdfDocument } from "@/modules/StockInventory/components/InventoryPdfDocument";
import { AuditPdfDocument } from "@/modules/StockInventory/components/AuditPdfDocument";

export async function generateInventoryPdf(data: StockInventoryReportItem[]) {
  try {
    const blob = await pdf(InventoryPdfDocument({ data })).toBlob();

    saveAs(
      blob,
      `inventario_estoque_${new Date().toLocaleDateString("pt-BR")}.pdf`
    );
  } catch (error) {
    console.error("Erro ao gerar PDF:", error);
    throw new Error("Não foi possível gerar o PDF.");
  }
}

export async function generateAuditPdf(data: StockInventoryReportItem[]) {
  try {
    const blob = await pdf(AuditPdfDocument({ data })).toBlob();

    saveAs(
      blob,
      `auditoria_inventario_${new Date().toLocaleDateString("pt-BR")}.pdf`
    );
  } catch (error) {
    console.error("Erro ao gerar PDF de auditoria:", error);
    throw new Error("Não foi possível gerar o PDF de auditoria.");
  }
}

export async function generateInventoryExcel(data: StockInventoryReportItem[]) {
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Inventário");

    worksheet.columns = [
      { header: "ID do Produto", key: "productId", width: 30 },
      { header: "Código", key: "code", width: 20 },
      { header: "Nome", key: "name", width: 40 },
      { header: "Contagem", key: "count", width: 15 },
    ];

    data.forEach((item) => {
      worksheet.addRow({
        productId: item.productId,
        code: item.code,
        name: item.name,
        count: "",
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      blob,
      `inventario_estoque_${new Date().toLocaleDateString("pt-BR")}.xlsx`
    );
  } catch (error) {
    console.error("Erro ao gerar Excel:", error);
    throw new Error("Não foi possível gerar o Excel.");
  }
}
